import React, { useState } from "react";
import { ShieldPlus, ShieldMinus } from "lucide-react";
import FormTemplate from "@/components/templates/FormTemplate";
import PermissionAssignForm from "@/components/organisms/PermissionAssignForm";
import PermissionRemoveForm from "@/components/organisms/PermissionRemoveForm";

function PermissionSets() {
  const [activeTab, setActiveTab] = useState("assign");

  const tabs = [
    { id: "assign", label: "Assign Permission", icon: ShieldPlus },
    { id: "remove", label: "Remove Permission", icon: ShieldMinus },
  ];

  return (
    <FormTemplate title="Permission Set Assignments">
      <div className="space-y-6">
        {/* Tabs */}
        <div className="border-b border-gray-200">
          <nav className="flex space-x-4" aria-label="Tabs">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  py-4 px-1 border-b-2 font-medium text-sm flex items-center space-x-2
                  transition-colors duration-200 whitespace-nowrap
                  ${
                    activeTab === tab.id
                      ? "border-orange-500 text-orange-600"
                      : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                  }
                `}
              >
                <span className="text-lg"><tab.icon size={18} /></span>
                <span>{tab.label}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="mt-6">
          {activeTab === "assign" && <PermissionAssignForm />}
          {activeTab === "remove" && <PermissionRemoveForm />}
        </div>
      </div>
    </FormTemplate>
  );
}

export default PermissionSets;
